// extracted by mini-css-extract-plugin
export default {"wrapper":"FclQRy","icons":"AZIAhe","withIcons":"KKq92K","user":"BTkqUF","name":"lS9OVw","arrowWrapper":"kbGchq","arrow":"AYUcWE","greetingText":"fPq1hC"};